/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <div>
    <img
      :src="$imgUrl.imgUrl(banner.pic)"
      alt=""
      class="news_banner"
    />
    <div :id="maxscrollTop ? 'commonGoTopNav' : ''" class="navBox">
      <div class="commonNavBox">
        <div
          :class="tabOpt == index ? 'tabList tabOpt' : 'tabList'"
          v-for="(item, index) in navList"
          :key="index"
          @click="tabOpt == index ? '' : handleClick(item, index)"
        >
          <div class="text">{{ item.catname }}</div>
        </div>
      </div>
    </div>
    <div class="infomationCenter">
      <div class="info_bottom">
        <div
          class="infoItem"
          v-for="(item, index) in infomationList"
          :key="index"
        >
          <img :src="$imgUrl.imgUrl(item.thumb)" alt="" class="articleimg" />
          <div class="infos">
            <div class="title artText textLinesLimit_1">{{ item.title }}</div>
            <div class="dec artText textLinesLimit_1">{{ item.description }}</div>
            <div class="articleBtn" @click="getUrl(item)">
              <div>阅读全文</div>
              <div>
                <img alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size='6' @current-change="changPage" >
        </el-pagination>
        总共 {{total}}
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from "../../src/axios/api.js";
export default {
  data() {
    return {
      maxscrollTop: false,
      navList: [
        
      ],
      tabOpt: 1,
      infomationList: [
        
      ],
      banner:[],
      total:0,
      currentPage:1,
      catid:'',
    };
  },
  created() {
    let id = this.$route.query.id;
    this.getInfomationList(id);
    this.catid=id
  },
  methods: {
    getInfomationList(catid) {
      var page=this.currentPage
      axios.get("/api/news/list",{catid:catid,page:page}).then((res) => {
        if (res.code == 1) {
          this.navList=res.data.category;
          this.infomationList=res.data.list.data;
          this.banner=res.data.banner[0];
          this.total=res.data.list.total
        }
      });
    },
    changPage(val){
      this.currentPage=val;
      this.getInfomationList(this.catid);
    },
    getUrl(item){
      this.$router.push({ name: "newListDetail", query: {id:item.id,catid:item.catid,type:2}});
    },
    handleClick(item, index) {
      var that = this;
      var name= item.url.replace("/","");
      this.$router.push({ name: name, query: {id:item.id} });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 578) {
        this.maxscrollTop = true;
      } else {
        this.maxscrollTop = false;
      }
    },
    linkUrl(url) {
      window.location.href = url;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style  scoped>
.news_banner {
  width: 100%;
  height: 520px;
  background: #f4f7f2;
}
.navBox {
  padding: 0 12%;
  box-sizing: border-box;
  justify-content: flex-start;
}
.infomationCenter {
  /* padding: 0 260px; */
  box-sizing: border-box;
  width: 72%;
  margin: 0 auto;
}
.info_top {
  height: 510px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.info_top .articleimg {
  width: 700px;
  height: 420px;
  background: #f4f7f2;
  margin: 30px 45px 60px 0;
  box-sizing: border-box;
}
.info_top .infos {
  width: 100%;
  height: 100%;
  padding: 78px 0 0 0;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
}
.artText {
  font-weight: 400;
  line-height: 42px;
}
.info_top .title {
  font-size: 26px;
  color: #333333;
}
.info_top .dec {
  font-size: 18px;
  color: #666666;
}
.info_top .time {
  font-size: 14px;
}
.info_top .articleBtn {
  margin-top: 55px;
}

.info_bottom {
  /* width: 100%; */
  display: flex;
  /* justify-content: space-between; */
  align-items: flex-start;
  flex-wrap: wrap;
  margin:0 -10px;
  margin-top: 48px;
}
.infoItem {
  width: 32%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin: 0 0.66%;
  margin-bottom: 48px;
}
.infoItem .title:hover {
  color: #009144;
}
.infoItem .dec:hover {
  color: #009144;
}
.infoItem .articleimg {
  width: 100%;
  height: 332px;
  background: #f7f7f7;
  flex-shrink: 0;
}
.info_bottom .title{
  font-size: 18px;
  font-weight: 400;
  color: #333333;
}
.info_bottom .dec {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-bottom: 20px;
}
.infoItem .title:hover {
  color: #009144;
}
.infoItem .dec:hover {
  color: #009144;
}

.infoItem .articleBtn:hover {
  background: #009144;
}
.infoItem .articleBtn:hover div {
  font-size: 16px;
  color: #fcfcfe;
}
.infoItem .articleBtn:hover img {
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_white.png);
}
.articleBtn {
  /* position: absolute;
  bottom: 16px;
  right: 50px; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 124px;
  height: 38px;
  padding: 11px 14px;
  box-sizing: border-box;
  border: 1px solid #cccccc;
}
.articleBtn div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.articleBtn img {
  margin-left: 8px;
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_gray.png);
}
.articleBtn:hover {
  background: #009144;
}
.articleBtn:hover div {
  font-size: 16px;
  color: #fcfcfe;
}
.articleBtn:hover img {
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_white.png);
}
.pagination {
  margin-top: 48px;
  margin-bottom: 90px;
}

/* /deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  width: 40px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
} */
</style>